import * as path from "node:path";
const buildSliceLibraryDirectoryPath = (args) => {
  return args.absolute ? args.helpers.joinPathFromRoot(args.libraryID) : path.join(args.libraryID);
};
export {
  buildSliceLibraryDirectoryPath
};
//# sourceMappingURL=buildSliceLibraryDirectoryPath.js.map
